import React from 'react';
import PropTypes from 'prop-types';
import useScript from '@lmig/dotcom-aspect-hooks/useScript';

const Script = ({ className = '', url, children }) => {
  const [loaded, error] = useScript(url);

  return loaded && !error && <div className={className}>{children}</div>;
};

Script.propTypes = {
  className: PropTypes.string,
  url: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};

export default Script;
